import { ModalHandler } from "@lib/ModalHandler";
import { getRandomizedString, randNum } from "@lib/util/common";
import { Accessor } from "solid-js";
import {
  clickSaveButton,
  getQuestionHandler,
  waitForRegularSectionPage,
  waitForSOMainMenu,
} from "../form_handlers";
import { clickSurveySection } from "../form_util";

export async function completeLavPresets(totalInStock: number, modalHandler: Accessor<ModalHandler>) {
  await fillShelfBefore(modalHandler);
  await fillShelfAfter(totalInStock, modalHandler);

  await fillUnitsAndCasesOverall(modalHandler);
  await fillDisplayMaintenance(modalHandler);
  await fillLavazzaIntelligence(modalHandler);
}

async function fillUnitsAndCasesOverall(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /units and cases overall/i,
    modalHandler,
    waitForRegularSectionPage,
    true
  );
  if (!clicked) {
    return;
  }

  getQuestionHandler("textinput", 1, "How many units of WHOLE BEANS did you packout?")?.answer("0");
  getQuestionHandler("textinput", 2, "How many cases of WHOLE BEANS did you ordered overall?")?.answer("0");
  getQuestionHandler("textinput", 3, "How many units of BAG did you packout?")?.answer("0");
  getQuestionHandler("textinput", 4, "How many cases of BAG did you ordered overall?")?.answer("0");
  getQuestionHandler("textinput", 5, "How many units of KCUP did you packout?")?.answer("0");
  getQuestionHandler("textinput", 6, "How many cases of KCUP did you ordered overall?")?.answer("0");
  getQuestionHandler("textinput", 7, "How many units of KICKING HORSE did you packout?")?.answer("0");
  getQuestionHandler("textinput", 8, "How many cases of KICKING HORSE did you ordered overall?")?.answer("0");

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}

async function fillDisplayMaintenance(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /display maintenance/i,
    modalHandler,
    waitForRegularSectionPage,
    true
  );
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("radio", 1, "Does the store have existing display(s)?")?.answer("NO");
  getQuestionHandler("radio", 6, "Did you build any new displays?")?.answer("NO");

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}

async function fillShelfBefore(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(/shelf before/i, modalHandler, waitForRegularSectionPage, true);
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("radio", 1, /did you rotate to the front of the shelf/i)?.answer("YES");

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}

async function fillShelfAfter(totalInStock: number, modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(/shelf after/i, modalHandler, waitForRegularSectionPage, true);
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  let totalStocked = randNum(3, 6);
  if (totalInStock < 3) totalStocked = 2;
  if (totalInStock === 0) totalStocked = 0;

  const tagsAdded = randNum(0, 1);

  getQuestionHandler("textinput", 1, "Unit(s) added to Shelf Outside of the Distribution check?")?.answer(
    totalStocked.toString()
  );
  getQuestionHandler("textinput", 2, "Tag(s) added to Shelf Outside of the Distribution check?")?.answer(
    tagsAdded.toString()
  );
  getQuestionHandler("textinput", 3, "Total Orders placed Outside of the Distribution check?")?.answer(
    randNum(0, 1).toString()
  );

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}

async function fillLavazzaIntelligence(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(
    /client intelligence/i,
    modalHandler,
    waitForRegularSectionPage,
    true
  );
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("radio", 1, /did you recommend.*to store managers/i)?.answer("YES");
  getQuestionHandler("radio", 2, /please confirm if you acknowledge the below attached promos/i)?.answer(
    "YES"
  );
  getQuestionHandler("radio", 3, /did you ensure that the.*sales tags.*are up?/i)?.answer("YES");
  getQuestionHandler(
    "radio",
    4,
    /two skus from tierra have been discd.*did you ensure they have been removed/i
  )?.answer("YES");
  getQuestionHandler(
    "radio",
    5,
    "Please refer to the kicking horse coffee skus below. Can you confirm that the store prioritizes ground cofee products"
  )?.answer("YES");
  getQuestionHandler("textinput", 6, /please provide a comment in this project/i)?.answer(
    getRandomizedString(["n", ".,/", "a"])
  );

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}
